var _toConsumableArray = require("/Users/okunoe01/workspace/digital-paper-edit-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

/**
* a module to create ADL(Audio Decision list) AES31 for SADIE - audio editing software 
*/
var Timecode = require('smpte-timecode');

var uuid1 = require('uuid/v1');

var moment = require('moment'); // Temporary helper function for python to js conversion


var str = function str(string) {
  return string;
};
/**
 * helper function to convert a set to an array
 * @param {*} set - a js Set - data structure object
 */


var convertSetToArray = function convertSetToArray(set) {
  return _toConsumableArray(set);
};
/**
 * get time in ISO format
 */


var getCurrentTime = function getCurrentTime() {
  return moment().format();
};
/**
 * 
 * @param {*} timecode - Timecode object from `smpte-timecode` 
 * inspired by from https://stackoverflow.com/questions/31385418/convert-timecode-to-seconds
 */


var tcToSec = function tcToSec(timecode) {
  var hours = timecode.hours * 60 * 60;
  var minutes = timecode.minutes * 60;
  var seconds = timecode.seconds;
  var frames = timecode.frames * (1 / timecode.frameRate);
  var totalTime = hours + minutes + seconds + frames;
  return totalTime;
};
/**
 * convert seconds to TCF Timecode object from smpte-timecode module
 * TCF assumes this format `HH:MM:SS:FF/0000` where `0000` is optional sample count.
 * @param {*} seconds - Int or float
 * @param {*} frameRate - Float
 */


var secsToTimecode = function secsToTimecode(seconds, frameRate) {
  var timeInFrames = seconds * frameRate; // Timecode module takes frames, frameRate and drop frame boolean as arguments

  var timecode = new Timecode(timeInFrames, frameRate, false); // avoid edge case of trying to subtract a frame from start of sequence

  if (tcToSec(timecode) !== 0) {
    // subtracting one frame to obtain `HH:MM:SS:FF` format
    timecode.subtract(1);
  }

  return timecode;
};
/**
 * @param {*} timecode - Timecode object from `smpte-timecode` 
 */


var timecodeToString = function timecodeToString(timecode) {
  return timecode.toString();
};
/**
 * @param {*} timecode - Timecode object from `smpte-timecode` 
 */


var timecodeToStringWithSampleCount = function timecodeToStringWithSampleCount(timecode) {
  return "".concat(timecode.toString(), "/0000");
};
/**
 * deepCopyTimecode
 * For when want to do add or subtract operation on a timecode 
 * without modifying the original timecode object
 * @param {*} timecode - Timecode object from `smpte-timecode` 
 */


var deepCopyTimecode = function deepCopyTimecode(timecode, frameRate, isDropFrame) {
  return new Timecode(timecodeToString(timecode), frameRate, isDropFrame);
};

var generateEDL = function generateEDL(_ref) {
  var _ref$projectOriginato = _ref.projectOriginator,
      projectOriginator = _ref$projectOriginato === void 0 ? 'Default Unspecified Project Originator' : _ref$projectOriginato,
      edits = _ref.edits,
      filePaths = _ref.filePaths,
      fileNames = _ref.fileNames,
      sampleRate = _ref.sampleRate,
      frameRate = _ref.frameRate,
      projectName = _ref.projectName,
      _ref$adlUid = _ref.adlUid,
      adlUid = _ref$adlUid === void 0 ? uuid1() : _ref$adlUid,
      _ref$projectCreatedDa = _ref.projectCreatedDate,
      projectCreatedDate = _ref$projectCreatedDa === void 0 ? getCurrentTime() : _ref$projectCreatedDa;
  var generatorVersion = '00.01';
  var projectTime = new Timecode('00:00:00:00');
  var edl = '';
  var verAdlVersion = '01.02';
  var adlId = '1234';
  /**
      * write header
      */

  edl += '<ADL>\n\n';
  /**
      * global version information
      */

  edl += '<VERSION>\n' + '\t(ADL_ID)\t' + adlId + '\n' + '\t(ADL_UID)\t' + adlUid + '\n' + '\t(VER_ADL_VERSION)\t' + verAdlVersion + '\n' + '\t(VER_CREATOR)\t"' + projectOriginator + '"\n' + '\t(VER_CRTR)\t' + generatorVersion + '\n' + '</VERSION>\n\n';
  /**
      * global project information
      */

  edl += '<PROJECT>\n' + '\t(PROJ_TITLE)\t"' + projectName + '"\n' + '\t(PROJ_ORIGINATOR)\t"' + projectOriginator + '"\n' + '\t(PROJ_CREATE_DATE)\t' + projectCreatedDate + '\n' + '\t(PROJ_NOTES)\t"_"\n' + '\t(PROJ_CLIENT_DATA)\t"test"\n' + '</PROJECT>\n\n';
  /**
      * global sequence information
      */

  edl += '<SEQUENCE>\n' + '\t(SEQ_SAMPLE_RATE)\tS' + str(sampleRate) + '\n' + '\t(SEQ_FRAME_RATE)\t' + str(frameRate) + '\n' + '\t(SEQ_ADL_LEVEL)\t1\n' + '\t(SEQ_CLEAN)\tFALSE\n' + '\t(SEQ_DEST_START)\t' + str(timecodeToString(projectTime)) + '/0000\n' + '</SEQUENCE>\n\n';
  /**
      * file locations
      * @todo: is this needed? I don't fully understand what this does
   * @todo: should probably be unique file path names
      */

  edl += '<SOURCE_INDEX>\n';
  convertSetToArray(filePaths).forEach(function (path, i) {
    var index = i + 1;
    edl += '\t(Index)\t' + str(index) + '\t(F)\t"URL:file://localhost/C:/Audio Files/' + fileNames[path] + '"\tBBCSPEECHEDITOR' + str(index) + '\t_\t_\t"_"\t"_"\n';
  });
  edl += '</SOURCE_INDEX>\n\n';
  /**
      *  edits
      */

  edl += '<EVENT_LIST>\n'; // TODO: loop over edits

  edits.forEach(function (edit, i) {
    var index = i + 1;
    var srcIn = secsToTimecode(edit['start'], frameRate);
    var srcOut = secsToTimecode(edit['end'], frameRate);
    var srcLen = srcOut.subtract(srcIn);
    var destIn = deepCopyTimecode(projectTime, frameRate, false);
    var destOut = deepCopyTimecode(projectTime, frameRate, false).add(srcLen);
    edl += '\t(Entry)\t' + str(index) + '\t' + '(Cut)\tI\t' + str(convertSetToArray(filePaths).indexOf(edit['path']) + 1) + '\t' + '1~2\t1~2\t' + str(timecodeToStringWithSampleCount(srcIn)) + '\t' + str(timecodeToStringWithSampleCount(destIn)) + '\t' + str(timecodeToStringWithSampleCount(destOut)) + '\t_' + '\t(Rem) NAME "' + edit['label'] + '"\n';
    projectTime = destOut;
  });
  edl += '</EVENT_LIST>\n\n';
  /**
      * write footer
      */

  edl += '</ADL>\n';
  return edl;
};

var getFileList = function getFileList(edits) {
  var filePaths = new Set();
  var fileNames = {}; // if the edits don't have a path attribute
  // use clipName as path

  edits = edits.map(function (edit) {
    if (!edit.path) {
      edit.path = edit.clipName;
    }

    return edit;
  });
  edits.forEach(function (edit) {
    filePaths.add(edit.path);
    fileNames[edit.path] = edit.clipName;
  });
  return {
    filePaths: filePaths,
    fileNames: fileNames
  };
};

var writeEDL = function writeEDL(_ref2) {
  var projectOriginator = _ref2.projectOriginator,
      edits = _ref2.edits,
      sampleRate = _ref2.sampleRate,
      frameRate = _ref2.frameRate,
      projectName = _ref2.projectName,
      adlUid = _ref2.adlUid,
      projectCreatedDate = _ref2.projectCreatedDate;

  var _getFileList = getFileList(edits),
      filePaths = _getFileList.filePaths,
      fileNames = _getFileList.fileNames;

  var edl = generateEDL({
    edits: edits,
    projectOriginator: projectOriginator,
    filePaths: filePaths,
    fileNames: fileNames,
    sampleRate: sampleRate,
    frameRate: frameRate,
    projectName: projectName,
    adlUid: adlUid,
    projectCreatedDate: projectCreatedDate
  }); // NOTE: in the python version the audio is included in the ADL via zipping etc.. altho not needed for client side use
  // SADiE will use the audio present in the workspace if not provided with the file

  return edl;
};

module.exports = writeEDL;